import React from "react";
import { connect } from "react-redux";
import { Popup, Button, ValidationGroup, CheckBox, TextBox } from "devextreme-react";
import TextField from "../../../../Shared/fields/TextField";
import SwitchField from "../../../../Shared/fields/SwitchField";
import SelectField from "../../../../Shared/fields/SelectField";
import TableFilter from "../../../../Shared/tableFilter";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { setEmpresa, openCloseModalEditarEmpresa, doGetEmpresa, doPutEmpresa, setBase64, doPostEmpresa, doGetDataEmpresa, getDocumentAgreement } from "./action";
import NumberField from "../../../../Shared/fields/NumberField";
import ReactDOM from "react-dom";
import DataGrid, { Column, RemoteOperations, Paging, Pager, MasterDetail } from "devextreme-react/ui/data-grid";
import moment from "moment";
import validaciones from "../../../../../helpers/validaciones";

import Form, {
  ButtonItem,
  GroupItem,
  SimpleItem,
  Label,
  CompareRule,
  EmailRule,
  PatternRule,
  RangeRule,
  RequiredRule,
  StringLengthRule
} from 'devextreme-react/ui/form';

class ModalEditar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activoPrev: null,
      modalStep: 1,
      disabled: false,
      rutEmpresa: null,
      checkAgreement: null,
      checkApprover: null,
      approverVisible: false,
      rutApprover: null,
      fileName: null,
      validRutStepOne: true,
      validRutModalApprover: true
    };

  }

  componentDidUpdate = (preProps) => {
    if (!preProps.isOpenModalEditar && this.props.isOpenModalEditar) {
      //const { empresa } = this.props;
    }
    if (preProps.base64file !== this.props.base64file && this.props.base64file) {
      this.handleFileUpload();
    }
    if (preProps.isNewEmpresa !== this.props.isNewEmpresa && this.props.isNewEmpresa === false && this.state.modalStep !== 2) {
      this.setState({ modalStep: 2 });
    }

    if (preProps.isNewEmpresa !== this.props.isNewEmpresa && this.props.isNewEmpresa === true && this.state.modalStep !== 1) {
      this.setState({ modalStep: 1 });
    }
  }

  handleFileSelect = (evt) => {
    this.setState({ fileName: evt.target.files[0].name });
    var f = evt.target.files[0]; // FileList object
    var reader = new FileReader();
    // Closure to capture the file information.
    reader.onload = ((theFile) => {
      return (e) => {
        var binaryData = e.target.result;
        //Converting Binary Data to base 64
        var base64String = window.btoa(binaryData);
        //showing file converted to base64
        let value = base64String;
        this.props.dispatch(setBase64(value));
      };
    })(f);
    // Read in the image file as a data URL.
    reader.readAsBinaryString(f);
  }

  handleChange = (e) => {
    const NewEmpresa = { ...this.props.empresa };

    if (e.element.id === "CheckApprover") {
      this.setState({ checkApprover: e.value });
    }

    if (e.element.id === "CheckAgreement") {
      this.setState({ checkAgreement: e.value });
    }

    if (e.element.id === "rutEmpresa") {
      this.setState({ rutEmpresa: e.value });
    }
    if (e.element.id === "rutApprover") {
      this.setState({ rutApprover: e.event.target.value });
    } else {
      NewEmpresa[e.element.id] = e.value;
      this.props.dispatch(setEmpresa(NewEmpresa));
    }
  }

  handleAdd = () => {
    const newEmpresa = { ...this.props.empresa };
    if (newEmpresa.isNoContent) {
      delete newEmpresa.isNoContent;
      this.props.dispatch(doPostEmpresa(newEmpresa));
    } else {
      this.props.dispatch(doPutEmpresa(newEmpresa));
    }
    this.props.dispatch(openCloseModalEditarEmpresa(false, {}, true));
    this.setState({ modalStep: 1 });
  }

  handleAddApprover = (params) => {
    params.preventDefault();
    let _value = params.target[0] && params.target[0].value;
    const newEmpresa = { ...this.props.empresa };
    const user = this.props.userInfo;
    this.setState({ validRutModalApprover: true }, () => {
      if (_value && validaciones.validateRut(_value)) {
        let newApprover = {
          Rut: _value,
          Author: user.FirstName + " " + user.LastName,
          CreationDate: new Date(),
          UserRegistered: true,
        }
        newEmpresa.Approvers.push(newApprover);
        this.props.dispatch(setEmpresa(newEmpresa));
      } else {
        this.setState({ validRutModalApprover: false })
      }
    })
  }

  handleVisible = (data) => {
    this.setState({ approverVisible: data, rutApprover: null });
  }

  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarEmpresa(false, {}, false));
    this.setState({ rutEmpresa: null, modalStep: 2 })
  }

  handleSave = (params) => {
    const result = params.validationGroup.validate();
    // if (result.isValid) {
    //   if (this.props.empresa) {
    //     this.props.dispatch(doAddCupo(this.props.empresa));
    //   } else if (this.state.activoPrev && !this.props.cupo.Activo) {
    //     this.props.dispatch(openCloseModalDesactivarCupo(true, this.props.empresa));
    //   } else {
    //     this.props.dispatch(doUpdateCupo(this.props.empresa));
    //   }
    // }
  }

  toStepTwo = (params) => {
    // const result = params.validationGroup.validate();
    // if (result.isValid) { this.setState({ modalStep: 2 }); }
    this.setState({ modalStep: 2 });
  }

  toApprovers = (params) => {
    this.setState({ modalStep: 3 });
  }

  toAgreements = (params) => {
    this.setState({ modalStep: 4 });
  }

  handleGetEmpresa = (params) => {
    params.preventDefault()
    let _value = params.target[0] && params.target[0].value;
    this.setState({ validRutStepOne: true }, () => {
      if (_value && validaciones.validateRut(_value)) {
        this.props.dispatch(doGetDataEmpresa(_value));
      } else {
        this.setState({ validRutStepOne: false })
      }
    })
  }

  handleFileUpload = () => {

    const newEmpresa = { ...this.props.empresa };
    let fecha = moment().format("YYYY-MM-DD HH:mm:ss");
    let newAgreement = {
      AgreementId: 4,
      Name: this.state.fileName,
      FileString: this.props.base64file,
      CreationDate: fecha
    }
    newEmpresa.Agreements.push(newAgreement);
    this.props.dispatch(setEmpresa(newEmpresa));
  }

  modalStepOne = () => {
    const empresa = this.props.empresa;
    return (<div>
      {this.props.isLoading && <LoadingOverlay />}
      <ValidationGroup >
        <div className="row">
          <form action={'your-action'} onSubmit={this.handleGetEmpresa} style={{ width: "100%", display: "flex" }}>
            <div className="col-9" style={{ marginTop: "-25px" }}>
              <div className="field-newDenuncia">
                <h3><p>Rut empresa</p></h3>
                <TextBox
                  id="rutEmpresa"
                  label="Rut empresa"
                  //value={this.state.rutEmpresa}
                  max={12}
                  isValid={this.state.validRutStepOne}
                  validationError={{ message: "RUT Inválido" }}
                //onChange={this.handleChange}
                //onValueChanged={this.handleChange}
                />
              </div>
            </div>
            <div className="col-3" style={{ marginTop: "25px" }} >
              <Button style={{ width: "100%" }} type="success" text="Buscar" useSubmitBehavior />
            </div>
          </form>
        </div>
      </ValidationGroup>
      <ValidationGroup >
        <div className="row">
          <div className="col-12">
            <TextField
              id="Description"
              label="Rut empresa"
              maxLength={20}
              value={empresa.CompanyRut}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <TextField
              id="CompanyName"
              label="Razón social"
              onChange={this.handleChange}
              maxLength={20}
              value={empresa.CompanyName}
              disabled={!empresa.CompanyRut}
            />
          </div>
        </div>
        <div className="button-row">
          <div>
            <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
          </div>
          <div>
            <Button text="Siguiente" type="success" onClick={this.toStepTwo} useSubmitBehavior disabled={!empresa.CompanyRut} />
          </div>

        </div>
      </ValidationGroup>
    </div>);
  }

  modalStepTwo = () => {
    const empresa = this.props.empresa;
    let selSegmentValue = this.props.listaSegmentoSel.find(x => x.ID === empresa.SelSegment);
    return (<div>
      {this.props.isLoading && <LoadingOverlay />}
      <ValidationGroup >
        <div className="row">
          <div className="col-11"><h4>{empresa.CompanyRut} {empresa.CompanyName}</h4></div>
        </div>
        <div className="row modal-empresa-border-bottom">
          <div className="col-6">
            <CheckBox
              onValueChanged={this.handleChange}
              id="SelService"
              value={empresa.SelService}
              width="100%"
              text="Servicio SEL (Preocupacional)"
            />
          </div>
          <div className="col-6">
            <SelectField
              id="SelSegment"
              label="Segmento SEL"
              value={selSegmentValue && selSegmentValue.ID}
              onChange={this.handleChange}
              items={this.props.listaSegmentoSel}
              displayExpr="Description"
              valueExpr="ID"
            />
          </div>
        </div>
        <div className="row modal-empresa-border-bottom">
          <div className="col-6">
            <NumberField
              inputAttr={{ maxLength: 3 }}
              max={99}
              min={0}
              label="Límite sin nombres"
              id="NoNameLimit"
              showSpinButtons
              onChange={this.handleChange}
              value={empresa.NoNameLimit}
              skipValidation
              disabled={false}
            />
          </div>
          <div className="col-6">
            <NumberField
              inputAttr={{ maxLength: 3 }}
              max={99}
              min={0}
              label="Plazo sin nombre"
              id="NoNameTime"
              showSpinButtons
              onChange={this.handleChange}
              value={empresa.NoNameTime}
              skipValidation
              disabled={false}
            />
          </div>
        </div>
        <div className="row modal-empresa-border-bottom" onClick={this.toApprovers} >
          <div className="col-11">Aprobadores {empresa.Approvers !== undefined ? <span>({empresa.Approvers.length})</span> : ""}</div>
          <div><i className="mantenedor-empresa-icon-inverted achs-icon">j</i></div>
        </div>
        <div className="row modal-empresa-border-bottom disabled">
          <div className="col-11">Baterias</div>
          <div><i className="mantenedor-empresa-icon-inverted achs-icon">j</i></div>
        </div>
        <div className="row modal-empresa-border-bottom disabled">
          <div className="col-11">Descuentos</div>
          <div><i className="mantenedor-empresa-icon-inverted achs-icon">j</i></div>
        </div>
        <div className="row modal-empresa-border-bottom" onClick={this.toAgreements}>
          <div className="col-11">Convenios {empresa.Approvers !== undefined ? <span>({empresa.Agreements.length})</span> : ""}</div>
          <div><i className="mantenedor-empresa-icon-inverted achs-icon">j</i></div>
        </div>
        <div className="button-row">
          <div>
            <Button text="Cancelar" onClick={this.handleCancel} />
          </div>
          <div>
            <Button text={this.props.isNewEmpresa ? "Agregar" : "Guardar"} type="success" onClick={this.handleAdd} useSubmitBehavior />
          </div>
        </div>
      </ValidationGroup>
    </div>);
  }

  modalApprovers = () => {
    const empresa = this.props.empresa;
    const showHide = this.state.approverVisible ? {} : { display: 'none' };
    return (<React.Fragment>
      {this.props.isLoading && <LoadingOverlay />}
      {/* <TableFilter
          placeholder="Buscar aprobador"
          //onChange={this.handleFilterChange}
          show
          format="#,##0.##"
          buttons={{
            newItem: {
              buttonName: "custom", visible: true, buttonAction: this.handleVisible, buttonText: "Agregar aprobador",
            },
          }}
        /> */}
      <div>
        <div className="row" style={{ marginBottom: "15px" }}>
          <form action="#" onSubmit={this.handleAddApprover} style={{ width: "100%", display: "flex" }}>
            <div className="col-9" style={{ marginTop: "-20px" }}>
              <TextField
                id="rutApprover"
                label="Rut aprobador"
                maxLength={20}
                //onChange={this.handleChange}
                //value={this.state.rutApprover}
                disabled={false}
                isValid={this.state.validRutModalApprover}
                validationError={{ message: "RUT Inválido" }}
              />
            </div>
            <div className="col-3" style={{ paddingTop: "25px" }}><Button style={{ width: "100%" }} type="success" text="Agregar" useSubmitBehavior /></div>
          </form>
        </div>
      </div>
      <DataGrid
        dataSource={empresa.Approvers}
        noDataText=""
        className="custom-table"
        showBorders={false}
        showColumnLines={false}
        allowColumnResizing={false}
        columnAutoWidth={false}
        showRowLines={false}
        onRowExpanding={(e) => {
          e.component.collapseAll(-1);
        }}
        rowAlternationEnabled
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
            const element = validaciones.noDataDOMElement(config, "Sin Información");
            //noDataSpan.appendChild(element);
          }
        }}
      >
        <Column
          alignment="center"
          dataField="Rut"
          caption="Aprobador"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <div>
                {/* <span className="modal-approver-checkbox">
                    <CheckBox
                      onValueChanged={this.handleChange}
                      id="CheckApprover"
                      value={this.state.checkApprover}
                      width="100%"
                      style={{ paddingBottom: 10 }}
                    />
                  </span> */}
                <span>
                  {row.data.Rut}
                </span>
              </div>
              , element
            );
          }}
        />

        <Column
          alignment="center"
          dataField="UserRegistered"
          caption="Rol asignado al trabajador"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <i className="mantenedor-empresa-icon achs-icon"> {row.data.UserRegistered ? 'X' : 'W'} </i>
              , element
            );
          }}
        />

        <Column
          alignment="center"
          dataField="Rut"
          caption="Creador"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <div>
                <div>
                  {row.data.Author}
                </div>
                <div>
                  {moment(row.data.CreationDate).format("DD/MM/YYYY")}
                </div>
              </div>
              , element
            );
          }}
        />

        <RemoteOperations
          paging={false}
          filtering
          summary={false}
          groupPaging={false}
          grouping={false}
          sorting={false}
        />

        <Paging
          defaultPageSize={7}
        />

        <Pager
          showNavigationButtons
          showInfo
          infoText={(page, total) => `Página ${page} de ${total}`}
        />

      </DataGrid>

    </React.Fragment>);
  }

  handleViewAgreement = (rutEmpresa, idAgreement) => {
    this.props.dispatch(getDocumentAgreement(rutEmpresa, idAgreement))
  }

  modalAgreements = () => {
    const empresa = this.props.empresa;
    return (<React.Fragment>
      {this.props.isLoading && <LoadingOverlay />}

      <div className="row">
        <div className="col-9">
          {/* <TableFilter
            placeholder="Buscar convenio"
            //onChange={this.handleFilterChange}
            filters={this.props.filtrosEmpresas}
            show
            format="#,##0.##"
          /> */}
        </div>
        <div className="col-3">
          <div className="agregar-convenio-button">
            <input
              accept=".txt"
              className="d-none"
              id={"fileSelect"}
              name="fileInput"
              value={this.state.FileInput}
              onChange={this.handleFileSelect}
              type="file"
            />
            <label htmlFor={"fileSelect"}>
              <Button text="Agregar convenio" type="success" />
            </label>
          </div>
        </div>
      </div>

      <DataGrid
        dataSource={empresa.Agreements}
        noDataText=""
        className="custom-table"
        showBorders={false}
        showColumnLines={false}
        allowColumnResizing={false}
        columnAutoWidth={false}
        showRowLines={false}
        onRowExpanding={(e) => {
          e.component.collapseAll(-1);
        }}
        rowAlternationEnabled
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
            const element = validaciones.noDataDOMElement(config, "Sin Información");
            //noDataSpan.appendChild(element);
          }
        }}
      >
        <Column
          alignment="center"
          dataField="Rut"
          caption="Nombre documento"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <div>
                {/* <span className="modal-approver-checkbox">
                    <CheckBox
                      onValueChanged={this.handleChange}
                      id="CheckAgreement"
                      value={this.state.checkAgreement}
                      width="100%"
                      style={{ paddingBottom: 10 }}
                    />
                  </span> */}
                <span>
                  {row.data.Name}
                </span>
              </div>
              , element
            );
          }}
        />

        <Column
          alignment="center"
          dataField="UserRegistered"
          caption="Fecha de subida"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <div>
                {moment(row.data.CreationDate).format("DD/MM/YYYY")}
              </div>
              , element
            );
          }}
        />

        <Column
          caption=""
          alignment="right"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <Button
                className="slimButton"
                type="success"
                text="Ver"
                disabled={this.props.isLoading}
                onClick={() => this.handleViewAgreement(empresa.CompanyRut, row.data.AgreementId)}
              />
              , element
            );
          }}
        />

        <RemoteOperations
          paging={false}
          filtering
          summary={false}
          groupPaging={false}
          grouping={false}
          sorting={false}
        />

        <Paging
          defaultPageSize={5}
        />

        <Pager
          showNavigationButtons
          showInfo
          infoText={(page, total) => `Página ${page} de ${total}`}
        />

      </DataGrid>

    </React.Fragment>);
  }

  render() {
    const { empresa } = this.props;

    let title = "Editar Empresa";

    if (this.props.isNewEmpresa) {
      title = "Agregar Empresa";
    }

    if (this.state.modalStep == 3) {
      title = "Agregar Aprobador";
    }
    if (this.state.modalStep == 4) {
      title = "Agregar Convenio";
    }

    return (
      <Popup
        toolbarItems={[
          {
            location: "before",
            widget: "dxButton",
            visible: this.state.modalStep > 2,
            options: {
              height: 40,
              html: `${this.state.modalStep > 2 ? '<div class="contenedor-icon-header" onClick=><i class="mantenedor-empresa-icon-header achs-icon">j</i></div>' : ''}`,
              onClick: this.toStepTwo,
              template: (c, e) => {
                e.innerHTML = `${this.state.modalStep > 2 ? '<div class="contenedor-icon-header" onClick=><i class="mantenedor-empresa-icon-header achs-icon">j</i></div>' : ''}`
              }
            }
          },
          {
            html: `${title}`,
            location: "before",
          },
          {
            html: `<div>Paso <span style="color: #00b2a9">${this.state.modalStep > 2 ? '2' : this.state.modalStep}</span> de <span style="color: #00b2a9">2</span></div>`,
            location: "after",
          },
        ]}
        //onShowing={() => { this.setState({ modalStep: 1 }); }}
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEditar}
        width={700}
        maxHeight={600}
        contentComponent={() => {
          switch (this.state.modalStep) {
            case 1:
              return this.modalStepOne();
            case 2:
              return this.modalStepTwo();
            case 3:
              return this.modalApprovers();
            case 4:
              return this.modalAgreements();
            default:
              return "";
          }
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorEmpresas.isLoading,
  listaEmpresas: state.mantenedorEmpresas.listaEmpresas,
  listaEmpresasFiltradas: state.mantenedorEmpresas.listaEmpresasFiltradas,
  filtrosEmpresas: state.mantenedorEmpresas.filtrosEmpresas,
  empresa: state.mantenedorEmpresas.empresa,
  isOpenModalEditar: state.mantenedorEmpresas.isOpenModalEditar,
  isOpenModalDesactivar: state.mantenedorEmpresas.isOpenModalDesactivar,
  empresa: state.mantenedorEmpresas.empresa,
  isNewEmpresa: state.mantenedorEmpresas.isNewEmpresa,
  listaSegmentoSel: state.mantenedorEmpresas.listaSegmentoSel,
  userInfo: state.global.userData,
  base64file: state.mantenedorEmpresas.base64file,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditar);


